import { Link } from "react-router-dom";
import { ArrowRight, Flag } from "lucide-react";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";
import { Button } from "../components/ui/button";
import { CITIZENSHIP_SERVICES, IMAGES } from "../data/content";

export default function Citizenship() {
  return (
    <div data-testid="citizenship-page">
      <PageHero
        eyebrow="Citizenship"
        title="Citizenship & Long-Term Planning"
        lead="Becoming a U.S. citizen is the milestone that turns a journey into a home. We help you review eligibility, prepare your application, practice for your interview, and plan what comes after."
        image={IMAGES.community}
        alt="Community celebration and belonging"
      />

      <section className="py-16 lg:py-24" data-testid="citizenship-services">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-4">
              <div className="h-11 w-11 rounded-xl bg-teal-light flex items-center justify-center mb-5">
                <Flag className="h-5 w-5 text-teal" />
              </div>
              <h2 className="text-2xl sm:text-3xl font-serif font-semibold text-navy tracking-tight">From green card to citizen</h2>
              <p className="mt-4 text-base text-mutedink leading-relaxed">
                We prepare you for every step — the N-400, the civics and English tests, the interview, and the oath ceremony — within our authorized scope.
              </p>
              <Button asChild className="mt-6 bg-teal text-white hover:bg-teal-dark hover:text-white rounded-full" data-testid="citizenship-start-button">
                <Link to="/start">Check My Eligibility <ArrowRight className="ml-2 h-4 w-4" /></Link>
              </Button>
            </div>
            <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {CITIZENSHIP_SERVICES.map((s) => (
                <div key={s} className="flex items-start gap-3 bg-surface border border-line rounded-lg p-4">
                  <span className="mt-1.5 h-2 w-2 rounded-full bg-champagne-dark flex-shrink-0" />
                  <span className="text-sm text-ink">{s}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-[#101315]" data-testid="citizenship-next">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl font-serif font-semibold text-cream tracking-tight">Citizenship is not the end of the journey.</h2>
          <p className="mt-4 text-lg text-cream/70 leading-relaxed">
            After naturalization, we help with your first U.S. passport, petitioning for family members, and long-term planning for your family's future. Full Circle means we stay beside you for the next milestone.
          </p>
        </div>
      </section>

      <CTASection title="Ready to prepare for citizenship?" primaryLabel="Explore Citizenship Services" />
    </div>
  );
}
